import { useContext } from "react";
import { QuestionsContext } from "../contexts/QuestionsProvider";

export default function useQuestions() {
  const context = useContext(QuestionsContext);

  if (!context) {
    throw new Error("Please Use QuestionsProvider in parent component.");
  }

  return context;
}
